import { render, staticRenderFns } from "./EstadoDeCuentasIndex.vue?vue&type=template&id=0f4b1285&scoped=true"
import script from "./EstadoDeCuentasIndex.vue?vue&type=script&lang=js"
export * from "./EstadoDeCuentasIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4b1285",
  null
  
)

export default component.exports